import Vue from 'vue';
import Vuex from 'vuex';
import httpUtils from '@/utils/http-utils';

import blog from './modules/blog';
import configuration from './modules/configuration';
import errorHandling from './modules/error-handling';
import notification from './modules/notification';
import payment from './modules/payment';
import product from './modules/product';
import provider from './modules/provider';
import shoppingCart from './modules/shopping-cart';
import subscription from './modules/subscription';
import user from './modules/user';
import filter from './modules/filter';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';

Vue.use(Vuex);

import ReadMore from 'vue-read-more';
Vue.use(ReadMore);

const debug = window.processEnv.VUE_APP_NODE_ENV !== 'production';
const store = new Vuex.Store({
  modules: {
    blog,
    configuration,
    errorHandling,
    notification,
    payment,
    product,
    provider,
    shoppingCart,
    subscription,
    user,
    filter,
  },
  actions,
  state: {
    pendingRequestCount: 0,
  },
  mutations,
  getters,
  strict: debug,
});

httpUtils.setStore(store);

export default store;
